module.exports = __webpack_public_path__ + "static/gears-db1edc28f45dd7ba97af7315e4f8243f.jpg";